import {RECRUITMENT_DETAIL_RESOURCE_TYPE} from '../../../../../core/entities/recruitment/constants';
import type {RecruitmentDetailResource} from '../../../../../core/entities/recruitment/schema';
import {CommonLink} from '../../../../../shared/components/CommonLink';

export const ResourceLinkItem: React.FC<{
  resource: RecruitmentDetailResource;
}> = ({resource}) => {
  if (resource.resourceType !== RECRUITMENT_DETAIL_RESOURCE_TYPE.LINK) return;

  return (
    <div className="mt-8">
      <CommonLink
        href={resource.content}
        className="text-link text-base leading pc:hover:opacity-80"
        target="_blank"
      >
        {resource.title}
      </CommonLink>
    </div>
  );
};
